import React from 'react';
import { FileCheck, Download, Calendar, FileText } from 'lucide-react';

const SessionRecordsSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-[#F59E0B] to-[#FBBF24] rounded-xl flex items-center justify-center">
          <FileCheck className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h2 className="text-3xl font-black  style={{ color: primaryColor }}">الضبوط الرسمية (محاضر الجلسات)</h2>
      </div>

      {caseData.sessionRecords && caseData.sessionRecords.length > 0 ? (
        <div className="space-y-6">
          {caseData.sessionRecords.map((record) => (
            <div 
              key={record.id}
              className="border-2 border-gray-200 rounded-xl p-6 hover:border-[#F59E0B] transition-all hover:shadow-lg bg-white"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#F59E0B] to-[#FBBF24] rounded-xl flex items-center justify-center">
                    <FileCheck className="w-6 h-6 text-white" strokeWidth={2.5} />
                  </div>
                  <div>
                    <h3 className="text-xl font-black text-gray-900">{record.title}</h3>
                    <span className="inline-block px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-xs font-bold mt-1">
                      {record.sessionNumber}
                    </span>
                  </div>
                </div>
                {record.canDownload && (
                  <button className="px-4 py-2 bg-[#C8A870] hover:bg-[#1E3A8A] text-white rounded-lg transition-colors flex items-center gap-2 font-bold">
                    <Download className="w-4 h-4" />
                    <span>تحميل</span>
                  </button>
                )}
              </div>

              <div className="bg-amber-50 rounded-lg p-4 mb-4">
                <div className="flex items-center gap-2 text-[#F59E0B] mb-2">
                  <FileText className="w-5 h-5" />
                  <span className="font-bold text-sm">ملخص المحضر</span>
                </div>
                <p className="text-gray-800 leading-relaxed">{record.summary}</p>
              </div>

              {record.content && (
                <div className="bg-white rounded-lg p-4 border-2 border-gray-100 mb-4">
                  <div className="flex items-center gap-2 text-gray-700 mb-2">
                    <FileText className="w-5 h-5  style={{ color: primaryColor }}" />
                    <span className="font-bold text-sm">محتوى المحضر</span>
                  </div>
                  <p className="text-gray-700 leading-relaxed">{record.content}</p>
                </div>
              )}

              <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                <div className="flex items-center gap-2 text-gray-700">
                  <Calendar className="w-5 h-5  style={{ color: primaryColor }}" />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">تاريخ الجلسة</div>
                    <div className="font-bold">{record.date}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <FileCheck className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-lg font-bold">لا توجد ضبوط رسمية</p>
        </div>
      )}
    </div>
  );
};

export default SessionRecordsSection;